<template>
  <div class="app-page">
    <Header ref="header" helpURL="studio/">
      <template #header-slot>
        <BreadcrumbNavigation />
        <button id="header-go-to-projects-btn" class="button link-button" @click="router.back();">Back</button>
      </template>
      <template #page-slot>
        Release Notes
      </template>
      
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <div class="dash-container">
          <h2>Current Release</h2>
          <Collapsible v-for="item in current" :key="item" :title="`Version: ${item.version}`">
            <ReleaseEntry 
              :features="item.features"
              :fix="item.fix"
              :issues="item.issues"
            />
          </Collapsible>
          
          <h2>Upcoming Release</h2>
          <Collapsible v-for="item in upcoming" :key="item" :title="`Version: ${item.version}`">
            <ReleaseEntry 
              :features="item.features"
              :fix="item.fix"
              :issues="item.issues"
            />
          </Collapsible>
      
          <h2>Old Releases</h2>
          <Collapsible v-for="item in old" :key="item" :title="`Version: ${item.version}`">
            <ReleaseEntry 
              :features="item.features"
              :fix="item.fix"
              :issues="item.issues"
            />
          </Collapsible>
        
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed,onMounted,ref } from 'vue';
import Header from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import Collapsible from '@/components/News/Collapsible.vue';
import ReleaseEntry from '@/components/News/ReleaseEntry.vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const isLoading=ref(false);
const upcoming=ref([]);
const current=ref([]);
const old=ref([]);
const S3BaseUrl = 'https://studio-release-notes.s3.us-west-2.amazonaws.com/';



onMounted(async () => {
  isLoading.value = true;
  GetReleaseNotes();
  isLoading.value = false;
});

async function GetReleaseNotes() {
  const url = `${S3BaseUrl}list.json?cacheBust=${Date.now()}`;
  const response = await fetch(url, { cache: "no-store" });
  let list = await response.json();

  upcoming.value = list.filter(item => item.status === "future"); 
  current.value = list.filter(item => item.status === "current"); 
  old.value = list.filter(item => item.status === "old"); 




}

</script>

<style lang="scss" scoped>

.main-display-area {
  overflow-y: auto;
}

.dash-container {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
}

@media (max-width: $breakpoint-lg) {
  .dash-container {
    flex-direction: column;
  }
}

.link-button {
  background: var(--color-primary-400);
  width: 120px;
  border-radius: 6px;
  border:var(--color-primary-200) solid 1px;
  align-self: self-end;
}

.link-button:hover {
  background:  var(--color-primary-300);
}

</style>
